import { motion } from "framer-motion";
import { glowButton } from "../animations";
import * as Icons from "lucide-react";

export const PremiumButton = ({ 
  children, 
  onClick, 
  variant = "primary",
  size = "lg",
  icon: Icon,
  className = "",
  ...props 
}) => {
  const variants = {
    primary: "bg-gradient-to-r from-[#1f7db6] to-[#143e6e] text-white",
    secondary: "bg-white text-[#143e6e] border-2 border-[#1f7db6]/20"
  };

  const sizes = {
    sm: "px-6 py-2 text-sm",
    md: "px-8 py-3 text-base",
    lg: "px-10 py-4 text-lg"
  };

  return (
    <motion.button
      variants={glowButton}
      initial="rest"
      whileHover="hover"
      whileTap="tap"
      onClick={onClick}
      className={`
        relative
        ${variants[variant]}
        ${sizes[size]}
        rounded-full
        font-semibold
        inline-flex items-center justify-center gap-3
        transition-all duration-300
        shadow-lg hover:shadow-2xl
        ${className}
      `}
      {...props}
    >
      <span className="relative z-10 flex items-center gap-2">
        {children}
        {Icon && <Icon size={20} />}
      </span>
      
      {/* Glow effect */}
      {variant === "primary" && (
        <motion.div
          className="absolute inset-0 rounded-full bg-gradient-to-r from-[#1f7db6] to-[#143e6e] blur-xl opacity-0 group-hover:opacity-50"
          initial={{ opacity: 0 }}
          whileHover={{ opacity: 0.5 }}
          transition={{ duration: 0.3 }}
        />
      )}
    </motion.button>
  );
};
